import { AddProps } from './Add.typed';
import { Icon } from '../../../Icon/Icon';
import { Text } from '../../../Text/Text';
import { Box } from '../../../Box/Box';
import * as Styled from './Add.styled';
import React from 'react';

const Add = React.forwardRef<HTMLButtonElement, AddProps>((props, ref) => {
  const { max, onClick, count } = props;

  return (
    <Styled.Button onClick={onClick} type="button" ref={ref}>
      <Box position="absolute" top="50%" left="50%" center={true}>
        <Icon name="AddCircleOutline" size="2xl" />
        <Text size="s">
          {count}/{max}
        </Text>
      </Box>
    </Styled.Button>
  );
});

export { Add };
